import React from 'react';
import {
  BrowserRouter as Router,
  Prompt,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import Agreements from '../agreements/Routes';
import Benchmarks from '../benchmarks/Benchmarks';
import Brands from '../brands/Routes';
import Campaigns from '../campaigns/Routes';
import Contacts from '../contacts/Routes';
import Dashboards, { DefaultDashboard } from '../dashboard/Routes';
import Announcements from '../generic/Announcements/Announcements';
import { guardShape } from '../generic/change-guard';
import DocumentTitle from '../generic/DocumentTitle';
import ErrorComponent from '../generic/Error';
import { FlashMessageContainer } from '../generic/flash-messages';
import VersionCheck from '../generic/VersionCheck';
import Invoices from '../invoices/Routes';
import MerchantAttribution from '../merchant-attribution/Routes';
import Merchants from '../merchants/Routes';
import Opportunities from '../opportunities/Routes';
import Project from '../project/Routes';
import Quotes from '../quotes/Routes';
import SignInAuthorized from '../signin/dialog/Authorized';
import SignInStart from '../signin/dialog/Start';
import RequireSignIn from '../signin/RequireSignIn';
// import SKUSearch from '../sku-search/Routes';
import TargetSupplier from '../target-suppliers/Routes';
import Users from '../users/Routes';
import Content from './Content/Content.container';
import Favicon from './Favicon';
import Header from './Header';
import SalesforceContractGenerator from './SalesforceContractGenerator';

export const HealthCheck = () => <div>OK</div>;

export const PageNotFound = () => (
  <DocumentTitle title="Page not found">
    <ErrorComponent error={{ message: 'Page not found' }} />
  </DocumentTitle>
);

function getUserConfirmation(guard) {
  return function askConfirmation(message, callback) {
    const allowTransition = window.confirm(message); // eslint-disable-line no-alert
    if (allowTransition) guard.reset();
    callback(allowTransition);
  };
}

function Routes({ guard }) {
  return (
    <Router getUserConfirmation={getUserConfirmation(guard)}>
      <>
        <Favicon status={guard.modified ? 'modified' : 'default'} />

        <Switch>
          {/* Do not render the default app layout for sign-in dialog */}
          <Route path="/login/start" component={SignInStart} />
          <Route path="/login/authorized" component={SignInAuthorized} />

          {/* We need to skip authorization requests */}
          <Route path="/health" component={HealthCheck} />

          {/* Redirect from legacy "/login" route which users still have in their bookmarks */}
          <Route exact path="/login">
            <Redirect to="/" />
          </Route>

          <Route>
            <RequireSignIn>
              <FlashMessageContainer />
              <VersionCheck />

              <Header />
              <Content>
                <Prompt
                  message="It seems like you have unsaved changes. Are you sure you want to leave?"
                  when={guard.modified}
                />

                <Switch>
                  <Route exact path="/" component={DefaultDashboard} />
                  <Route path="/agreements" component={Agreements} />
                  <Route path="/benchmarks" component={Benchmarks} />
                  <Route path="/brands" component={Brands} />
                  <Route path="/campaigns" component={Campaigns} />
                  <Route path="/contacts" component={Contacts} />
                  <Route path="/quotes" component={Quotes} />
                  <Route path="/invoices" component={Invoices} />
                  <Route path="/opportunities" component={Opportunities} />
                  <Route path="/project" component={Project} />
                  <Route path="/users" component={Users} />
                  {/* <Route path="/sku-search" component={SKUSearch} /> */}
                  <Route path="/merchants" component={Merchants} />
                  <Route path="/dashboard" component={Dashboards} />
                  <Route
                    path="/merchant-attribution"
                    component={MerchantAttribution}
                  />
                  <Route path="/target-supplier" component={TargetSupplier} />
                  <Route
                    path="/salesforce-contract"
                    component={SalesforceContractGenerator}
                  />
                  <Route component={PageNotFound} />
                </Switch>
              </Content>
              <Announcements />
            </RequireSignIn>
          </Route>
        </Switch>
      </>
    </Router>
  );
}

Routes.propTypes = {
  guard: guardShape.isRequired,
};

export default Routes;
